module.exports = __webpack_public_path__ + "img/编组 2(1).9a2c4893.png";